// extracted by mini-css-extract-plugin
module.exports = {"container":"Search_container__1lult","buttonContainer":"Search_buttonContainer__90Yj5","searchAddBlock":"Search_searchAddBlock__1E0jC"};